/* =============================================================================
   Monolith — hero.js
   Slideshow controller for sections/hero.liquid (fade, dots, arrows, autoplay,
   swipe, pause on hover / hidden tab, theme editor block selection).
   ============================================================================ */
(function () {
  'use strict';

  class HeroSlideshow {
    constructor(el) {
      this.el = el;
      this.slides = Array.from(el.querySelectorAll('[data-hero-slide]'));
      this.contents = Array.from(el.querySelectorAll('[data-hero-content]'));
      this.dots = Array.from(el.querySelectorAll('[data-hero-dot]'));
      this.index = 0;
      this.timer = null;
      this.autoplay = el.dataset.heroAuto === 'true' && this.slides.length > 1;
      this.speed = parseInt(el.dataset.heroSpeed, 10) || 5000;

      if (this.slides.length <= 1) return;

      el.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      el.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.heroDot, 10), true)));

      // Swipe
      let startX = null;
      el.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      el.addEventListener(
        'touchend',
        (e) => {
          if (startX === null) return;
          const delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1), true);
          startX = null;
        },
        { passive: true }
      );

      // Keyboard
      el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        if (e.key === 'ArrowRight') this.go(this.index + 1, true);
      });

      el.addEventListener('mouseenter', () => this.stop());
      el.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduceMotion) this.start();
    }

    go(index, userInitiated = false) {
      const total = this.slides.length;
      this.index = ((index % total) + total) % total;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.contents.forEach((content, i) => content.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.index);
        dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
      });
      if (userInitiated) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-hero]').forEach((el) => {
      if (el.__hero) el.__hero.stop();
      el.__hero = new HeroSlideshow(el);
    });
  }

  theme.onDocumentReady(() => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-hero-slide]');
    const hero = e.target.closest('[data-hero]');
    if (slide && hero && hero.__hero) {
      hero.__hero.stop();
      hero.__hero.go(parseInt(slide.dataset.heroSlide, 10));
    }
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const hero = e.target.closest('[data-hero]');
    if (hero && hero.__hero) hero.__hero.start();
  });
})();
